import gelaender_1 from './gelaender_1.jpg';
import gelaender_2 from './gelaender_2.jpg';

export const portfolio_edelstahlgelaender = [
    {product_img: gelaender_1},
    {product_img: gelaender_2}
]